import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import VueQuillEditor from 'vue-quill-editor' //富文本
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import './plug-in/customComponent.js'// 自定义组件
import './plug-in/element-ui.js'// 引入element-ui
// 局部打印图片
import Print from '../src/assets/js/print.js'
import './plug-in/china-area-data.js'// 引入中国区域数据
Vue.use(VueQuillEditor) //富文本
Vue.use(Print)
Vue.prototype.$printReportMod = ''
Vue.prototype.$printReportKey = ''
Vue.prototype.$isPrint = false
Vue.config.productionTip = false
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')